import { BlockStack, Card, Link } from '@shopify/polaris';
import BoldText from '@/components/BoldText';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { widgetSettingSelector } from '@/redux/slice/widget.slice';
import { openCrisp } from '@/helpers';
import { WidgetCartPageCard } from './WidgetCartPage';
import { WidgetProductPageCard } from './WidgetProductPage';
import { WIDGET_DISPLAY_CHOICE } from '@/constants/enum';

export const WidgetPlaceManually = () => {
  const { t } = useTranslation('widget_settings');
  const widgetSettings = useSelector(widgetSettingSelector);

  return (
    <Card padding={'300'}>
      <BlockStack gap={'300'}>
        <BoldText>{t('position.selector.title')}</BoldText>
        {widgetSettings.widgetPosition.displayOnPage.includes(WIDGET_DISPLAY_CHOICE.CART) && <WidgetCartPageCard />}
        {widgetSettings.widgetPosition.displayOnPage.includes(WIDGET_DISPLAY_CHOICE.PRODUCT) && <WidgetProductPageCard />}
        <Link removeUnderline onClick={openCrisp}>
          {t('position.selector.instruction')}
        </Link>
      </BlockStack>
    </Card>
  );
};
